import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { selectUser, setUser } from "../../core/auth/authSlice";
import { selectMessages } from "../../core/auth/chatSlice";
import { addNotifMessage } from "../../core/auth/notifSlice";
import { User } from "../../shared/models";
import { useWebSocket } from "../../shared/socket-provider/WebSocketProvider";
import "./Header.scss";

const MenuItems = () => {
	const user = useSelector(selectUser) as User;
	const disabledFunction = !user?.profileCompleted;
	const navigate = useNavigate();
	const location = useLocation();
	const messageState = useSelector(selectMessages);

	const [selectedBtn, setSelectedBtn] = useState(location.pathname);

	const unreadCount = user?.unreadMessagesCount || 0;
	const { t } = useTranslation();

	const socket = useWebSocket();

	const dispatch = useDispatch();

	useEffect(() => {
		if (!socket || !user?.actorId) return;

		const handleNewMessage = (newMessage: any) => {
			const isFromOtherUser = user.actorId !== newMessage.sender;
			const isInCurrentChat = messageState.activeChat.chatId === newMessage.chatId;

			if (isFromOtherUser && !isInCurrentChat) {
				dispatch(addNotifMessage());
				dispatch(setUser({
					...user,
					unreadMessagesCount: (user.unreadMessagesCount || 0) + 1,
				}));
			}
		};

		socket.on("newMessage", handleNewMessage);

		return () => {
			socket.off("newMessage", handleNewMessage);
		};
	}, [socket, user, messageState.activeChat.chatId, dispatch]);

	// useEffect(() => {
	// 	http.get(ChatApiRoutes.GET_UNREAD_CHATS);
	// }, []);

	return (
		<div className="menu-items d-none d-md-flex ">
			{!disabledFunction && (
				<>
					<ul className="navbar-nav me-auto mb-2 mb-lg-0 flex-row gap-5">
						<li className="nav-item">
							<div
								className={`nav-link ${
									selectedBtn.includes("board") ? "active" : ""
								}`}
								aria-current="page"
								onClick={() => {
									navigate("/board");
									setSelectedBtn("board");
								}}
							>
								{t("header.nav.board")}
							</div>
						</li>
						<li className="nav-item">
							<div
								className={`nav-link ${
									selectedBtn.includes("jobs") ? "active" : ""
								}`}
								aria-current="page"
								onClick={() => {
									navigate("/jobs");
									setSelectedBtn("jobs");
								}}
							>
								{t("header.nav.jobs")}
							</div>
						</li>
						<li className="nav-item position-relative">
							<div
								className={`nav-link ${
									selectedBtn.includes("messages") ? "active" : ""
								}`}
								aria-current="page"
								onClick={() => {
									navigate("/messages");
									setSelectedBtn("messages");
								}}
							>
								{t("header.buttons.messages")}
								{unreadCount && unreadCount > 0 ? (
									<span className="header__dot">{unreadCount}</span>
								) : null}
							</div>
						</li>
					</ul>
				</>
			)}
		</div>
	);
};

export default MenuItems;
